import type { Address } from '@/modules/address/domain/Address';
import type { AddressFormValues } from '@/sections/address/types/AddressFormValues';

export const addressFormToAddress = (
  addressForm: AddressFormValues
): Omit<Address, 'id'> => {
  const {
    'prefix-phone': prefixPhone,
    phone,
    'no-number': noNumber,
    streetNumber,
    ...rest
  } = addressForm;

  const phoneWithoutSpaces = phone?.replace(/\s/g, '');

  return {
    ...rest,
    phone: `${prefixPhone}${phoneWithoutSpaces}`,
    streetNumber: noNumber ? '' : streetNumber,
    latitude: addressForm?.lat ?? addressForm?.latitude,
    longitude: addressForm?.lon ?? addressForm?.longitude
  };
};
